import { PlusOutlined } from "@ant-design/icons";
import { Button, Form, message, Modal, Upload } from "antd";
import { UploadProps } from "antd/es/upload";
import { UploadFile } from "antd/lib";
import { FC, useState } from "react";
import { HiUpload } from "react-icons/hi";
import { useIntl } from "react-intl";
import { uploadImgSVG } from "../../../assets/SVGs/SVGs";

interface IMGUploaderProps {
  name?: string;
  fileList?: UploadFile[];
  setFileList?: React.Dispatch<React.SetStateAction<UploadFile<any>[]>>;
  maxCount?: number;
  additionalOnChange?: (fileList: UploadFile<any>[]) => void;
  imgValidation?: boolean;
  className?: string;
  listType?: "picture" | "picture-card" | "picture-circle" | "text";
}
const getBase64 = (file: any): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

const IMGUploader: FC<IMGUploaderProps> = ({
  fileList,
  setFileList,
  name = "image",
  maxCount = 1,
  additionalOnChange,
  imgValidation,
  listType = "picture-card",
  className,
}) => {
  const [localFileList, setLocalFileList] = useState<UploadFile[]>([]);
  const intl = useIntl();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as any);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url!.substring(file.url!.lastIndexOf("/") + 1)
    );
  };
  const handleCancel = () => setPreviewOpen(false);

  const handleUpload = async ({ file, onSuccess }: any) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  const handleChange: UploadProps["onChange"] = ({ fileList: newFileList }) => {
    if (imgValidation) {
      for (let i = 0; i < newFileList.length; i++) {
        if (newFileList[i]?.type) {
          if (newFileList[i]?.type?.includes("image")) {
            const fileSize = newFileList[i]?.size;

            if (fileSize !== undefined) {
              const isLt4M = fileSize / 1024 / 1024 < 4;
              if (!isLt4M) {
                newFileList.splice(i, 1);
                message.error(intl.formatMessage({ id: "imageSizeLt4MB" }));
              }
            }
          } else {
            newFileList.splice(i, 1);
            message.error(intl.formatMessage({ id: "imgNotValid" }));
            break;
          }
        }
      }
    }

    if (setFileList) {
      setFileList(newFileList);
    } else {
      setLocalFileList(newFileList);
    }
    if (additionalOnChange) {
      additionalOnChange(newFileList);
    }
  };

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>{intl.formatMessage({ id: "upload" })}</div>
    </button>
  );
  const uploadButtonCard = (
    <Button
      htmlType="button"
      type="default"
      className="text-color-primary bg-[#FBFBFF] border-none p-2 w-[300px] flex flex-wrap items-center justify-between  gap-1"
    >
      <div className="flex items-center gap-1">
        {uploadImgSVG("20", "30")}
        <span> {intl.formatMessage({ id: "uploadImg" })}</span>
      </div>
      <span>
        <HiUpload color="#3F4592" />
      </span>
    </Button>
  );
  const BTN = listType === "picture" ? uploadButtonCard : uploadButton;
  return (
    <div>
      <Form.Item
        name={name}
        required={false}
        className={`${className} flex justify-center w-full form-style`}
      >
        <Upload
          // action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
          listType={listType}
          accept="image/*"
          fileList={fileList ? fileList : localFileList}
          className=""
          customRequest={handleUpload}
          onPreview={handlePreview}
          onChange={handleChange}
          maxCount={maxCount}
          multiple={maxCount > 1}
        >
          {!!fileList
            ? fileList.length >= maxCount
              ? null
              : BTN
            : localFileList.length >= maxCount
            ? null
            : BTN}
        </Upload>
      </Form.Item>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
        width={700}
      >
        <img alt="example" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </div>
  );
};

export default IMGUploader;
